import { render, staticRenderFns } from "./BlockEditorComponent.vue?vue&type=template&id=80e03f12&"
import script from "./BlockEditorComponent.vue?vue&type=script&lang=js&"
export * from "./BlockEditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditorComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports